receiveControlModalController.$inject = ['$scope', '$uibModalInstance', 'controllerParams', 'siteId', 'companyId'];
export function receiveControlModalController($scope, $uibModalInstance, controllerParams, siteId, companyId) {

  $scope.submit = submit;
  $scope.cancel = cancel;

  init();

  function submit() {
    $uibModalInstance.close($scope.data);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {

    $scope.data = {
      'thread_control_metadata': controllerParams.thread_control_metadata
    };
    $scope.titleOfEditionPopin = controllerParams.titleOfEditionPopin;
    $scope.metadataInputLabel = controllerParams.metadataInputLabel;
    $scope.siteId = siteId;
    $scope.companyId = companyId;
  }

}
